
<!-- 前台顶部菜单栏递归组件 -->
<template>
    <b v-if="item.visible && item.visible == 0">
        <!-- 只有一个子节点 -->
        <el-menu-item
            v-if="hasOneShowingChild(item.submenu, item) && (!onlyOneChild.submenu || onlyOneChild.noShowingChildren) && !item.alwaysShow"
            :index="item.webPath"
            :key="item.webPath">
            <svg-icon :icon-class="onlyOneChild.webIcon || 'empty'" /> <span :title="$i18n.locale == 'zh'?onlyOneChild.menuName:onlyOneChild.menuNameEn" slot="title" class="menu-title">{{ $i18n.locale == 'zh'?onlyOneChild.menuName:onlyOneChild.menuNameEn }}</span>
        </el-menu-item>
        <!-- 有多个子节点 -->
        <el-submenu v-else :index="item.webPath">
            <span slot="title" class="menu-title" :title="$i18n.locale == 'zh'?item.menuName:item.menuNameEn">
                <svg-icon :icon-class="item.webIcon || 'empty'" /> {{ $i18n.locale == 'zh'?item.menuName:item.menuNameEn }}
            </span>
            <SidebarItem :item="child" v-for="child in item.submenu" :key="child.webPath" />
        </el-submenu>
    </b>
</template>

<script>
import SidebarItem from "./SidebarItem.vue";
export default {
    name: 'SidebarItem',

    components: {
        SidebarItem
    },

    props: {
        item: { //菜单对象
            type: Object,
            required: true
        }
    },

    data() {
        this.onlyOneChild = null
        return {

        };
    },

    mounted() {

    },

    methods: {
        //是否只有一个子节点
        hasOneShowingChild(submenu = [], parent) {
            if (!submenu) {
                submenu = [];
            }
            const showingChildren = submenu.filter(item => {
                if (item && item.visible && item.visible == 1) { //菜单状态（0显示 1隐藏）
                    return false
                } else {
                    // 如果只有一个子节点
                    this.onlyOneChild = item
                    return true
                }
            })
            // 当只有一个子路由器时，默认显示子路由器
            if (showingChildren.length === 1) {
                return true
            }
            // 如果没有要显示的子路由器，则显示父路由器
            if (showingChildren.length === 0) {
                this.onlyOneChild = { ...parent, webPath: '', noShowingChildren: true }
                return true
            }
            return false
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/SidebarItem.vue